import styled from 'styled-components';
import Theme from '../../../../styles/models/theme';

export const Container = styled.div`
  display: flex;
  padding: 5px 10px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h1<{theme: Theme}>`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${({theme}) => theme.secondary};
`;
